import Analytics from 'analytics';
import { GOOGLE_TAG_MANAGER_PLUGIN } from "./utilities/analytics/google-tag-manager";

/** The set of available analytics plugins. IMPORTANT: The key must match the plugin's `name` field */
export const ANALYTICS_PLUGINS = {
  google_tag_manager: GOOGLE_TAG_MANAGER_PLUGIN,
};

/**
 * A list of all plugin keys. Pass this to createAnalyticsEvent if you
 * want to send the event to all providers
 */
export const ALL_PLUGINS = Object.keys(ANALYTICS_PLUGINS);

// Initialize analytics with all plugins
const analytics = Analytics({
  app: 'deltamath',
  plugins: Object.values(ANALYTICS_PLUGINS)
});

export default analytics;

// Helper function to track events across all plugins
export const trackEvent = (eventName, eventProperties = {}) => {
  analytics.track(eventName, eventProperties);
};

// Helper function to track page views
export const trackPageView = (pathname, properties = {}) => {
  analytics.page({
    url: pathname,
    ...properties
  });
};
